import PropTypes from 'prop-types'
import React from 'react'

import Modal from '@vtex/styleguide/lib/Modal'

export default function RootModal(props) {
  const onClose = () => {
    props.onClose && props.onClose()
    props.closeModal()
  }
  const children = props.children || <div />
  const enhancedProps = { ...props, children, onClose }
  return <Modal {...enhancedProps} />
}

RootModal.defaultProps = {
  centered: true,
  closeOnEsc: true,
  closeOnOverlayClick: true,
  responsiveFullScreen: false,
  showBottomBarBorder: false,
  showCloseIcon: true,
  showTopBar: true,
}

RootModal.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  bottomBar: PropTypes.node,
  centered: PropTypes.bool,
  closeOnEsc: PropTypes.bool,
  closeOnOverlayClick: PropTypes.bool,
  isOpen: PropTypes.bool,
  onCloseTransitionFinish: PropTypes.func,
  responsiveFullScreen: PropTypes.bool,
  showBottomBarBorder: PropTypes.bool,
  showCloseIcon: PropTypes.bool,
  showTopBar: PropTypes.bool,
  title: PropTypes.string,
  closeModal: PropTypes.func,
}
